var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightColumn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 27,
    viewBox: "0 0 38 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1 0.700003C37.2333 1.56667 37.3 2.43334 37.3 3.30001C37.3 4.16667 37.3 4.86667 37.3 5.4C37.1667 9.4 36.4 13.2333 35 16.9C33.5333 20.5667 31.7667 23.8667 29.7 26.8L20.8 24.4C22.1333 21.4667 23.1667 18.3667 23.9 15.1C24.6333 11.8333 25 8.73334 25 5.8C25 5.26667 25 4.5 25 3.5C25 2.5 24.9333 1.56667 24.8 0.700003L37.1 0.700003ZM17 0.700003C17.1333 1.56667 17.2 2.43334 17.2 3.30001C17.2 4.16667 17.2 4.86667 17.2 5.4C17.0667 9.4 16.3 13.2333 14.9 16.9C13.4333 20.5667 11.6667 23.8667 9.6 26.8L0.699999 24.4C2.03333 21.4667 3.06666 18.3667 3.8 15.1C4.53333 11.8333 4.9 8.73334 4.9 5.8C4.9 5.26667 4.9 4.5 4.9 3.5C4.9 2.5 4.83333 1.56667 4.7 0.700003L17 0.700003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightColumn);
export default __webpack_public_path__ + "static/media/right-column.7084ec80aaf10ceb8c83567203b50292.svg";
export { ForwardRef as ReactComponent };